import styled from "styled-components";
import { colors } from "../../styles/global";

export const MyLabel = styled.label`
  font-weight: 700;
  text-align: start;
  display: block;
`;

export const MyLabelMarg = styled.label`
  font-weight: 700;
  text-align: start;
  display: block;
  margin-bottom: 0.7em;
`;
